export default __webpack_public_path__ + "static/media/8.2d32c3be.svg";